export const notifications = {
  Direct: "Directo",
  footer: {
    from_the_last_30_days: "de los últimos 30 días.",
    That_s_all_your_notifications: "Esas son todas tus notificaciones",
  },
  Last_Week: "La semana pasada",
  Mark_all_as_read: "Marcar todo como leido",
  Notifications: "Notificaciones",
  Older: "Más viejo",
  Product: "Producto",
  Show_unread_only: "Mostrar solo los no leídos",
  Today: "Hoy",
  Yesterday: "Ayer",
} as const;
